// Module
var code = "{{::anonymousHomeVm.message | translate}} ";
// Exports
module.exports = code;